
import { Link } from "react-router-dom";

export default function Copyright() {
	return (
		<>
			<p className="disclaimer">
				<Link title="Convert Image to PDF" to="/img-to-pdf">Img2pdf</Link>&#32;|&nbsp;
				<Link title="Convert PNG to PDF" to="/png-to-pdf">png2pdf</Link>&#32;|&nbsp;
				<Link title="Convert JPG to PDF" to="/jpg-to-pdf">jpg2pdf</Link>&#32;|&nbsp;
				<Link title="Convert GIF to PDF" to="/gif-to-pdf">gif2pdf</Link>&#32;|&nbsp;
				<Link title="Convert WEBP to PDF" to="/webp-to-pdf">webp2pdf</Link>&#32;|&nbsp;
				<Link title="Convert TIFF to PDF" to="/tiff-to-pdf">tiff2pdf</Link>&#32;|&nbsp;
				<Link title="Convert BMP to PDF" to="/bmp-to-pdf">bmp2pdf</Link>
			</p>
			<p className="disclaimer">
				Copyright (c) 2025-2026 | No files are stored on our servers. All file conversion is client-side | <Link to="/privacy">Privacy Policy</Link> | <Link to="/contact">Contact</Link>
			</p>

		</>
	);
}